import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ftl-quote-site-redirect',
  templateUrl: './site-redirect.component.html',
  styleUrls: ['./site-redirect.component.scss']
})
export class SiteRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log('SiteRedirectComponent: ngOnInit');
  }

}
